(function () {
    'use strict';

    angular
        .module('app.password-reset')
        .component('sc3PasswordReset', {
            templateUrl: 'app/password-reset/password-reset.component.html',
            controller: PasswordResetComponent,
            bindings: {
                ticket: '<data'
            }
        });

    var noop = angular.noop;

    PasswordResetComponent.$inject = ['$state', 'alert', 'passwordOptions', 'PasswordReset', 'passwordResetResources'];
    function PasswordResetComponent($state, alert, options, PasswordReset, resources) {
        var ctrl = this,
            rNonAlphanumeric = /[^a-zA-Z\d]/,
            rDigit = /\d/,
            rLowerCase = /[a-z]/,
            rUpperCase = /[A-Z]/;

        // properties
        ctrl.data = { newPassword: null, confirmPassword: null, email: null };
        ctrl.form = null;
        ctrl.passwordRequiredLength = options.requiredLength;

        // methods
        ctrl.$onInit = init;
        ctrl.resetPassword = resetPassword;
        ctrl.sendPasswordResetEmail = sendPasswordResetEmail;

        ctrl.validatePasswordMatch = validatePasswordMatch;
        ctrl.validatePasswordTooShort = validatePasswordTooShort;
        ctrl.validatePasswordRequiresNonAlphanumeric = validatePasswordRequiresNonAlphanumeric;
        ctrl.validatePasswordRequiresDigit = validatePasswordRequiresDigit;
        ctrl.validatePasswordRequiresLower = validatePasswordRequiresLower;
        ctrl.validatePasswordRequiresUpper = validatePasswordRequiresUpper;

        ///////////////////////////////////
        function init() {
            ctrl.data.username = ctrl.ticket.username;
        }

        function resetPassword() {
            var form = ctrl.form,
                data = ctrl.data;

            if (ctrl.form.$valid) {
                PasswordReset.resetPassword(null, data).$promise.then(success, error);
            }

            ////////////////////////////////

            function success() {
                alert.success(resources.passwordResetSucceeded).then(gotoLogin, noop);
            }

            function error(error) {
                alert.error(resources.passwordResetFailed);
            }
        }

        function sendPasswordResetEmail() {
            var form = ctrl.form,
                data = ctrl.data;

            if (ctrl.form.$valid) {
                PasswordReset.sendPasswordResetEmail(null, data).$promise.then(success, error);
            }

            //////////////////////////

            function success() {
                alert.success(resources.passwordResetEmailSucceeded).then(gotoLogin, noop);
            }

            function error(error) {
                alert.error(resources.passwordResetEmailFailed);
            }
        }

        function validatePasswordMatch(value) {
            var newPassword = ctrl.data.newPassword;
            return !value || !newPassword || newPassword === value;
        }
        function validatePasswordTooShort(value) {
            return !value || value.length >= options.requiredLength;
        }
        function validatePasswordRequiresNonAlphanumeric(value) {
            return !value || !options.requireNonAlphanumeric || rNonAlphanumeric.test(value);
        }
        function validatePasswordRequiresDigit(value) {
            return !value || !options.requireDigit || rDigit.test(value);
        }
        function validatePasswordRequiresLower(value) {
            return !value || !options.requireLowercase || rLowerCase.test(value);
        }
        function validatePasswordRequiresUpper(value) {
            return !value || !options.requireUppercase || rUpperCase.test(value);
        }

        function gotoLogin() {
            $state.go('login');
        }
    }
})();